<template>
  <div>
  <body>
  <div class="disable-scroll-x">
    <div
      style="
        background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
      "
    >
      <CRow class="ml-5 mr-5" style="width: -webkit-fill-available">
        <Mainlayout></Mainlayout>
        <!-- to hide mobile view -->
        <div class="ml-5 mr-5" style="width: inherit">
          <CRow>
            <div style="width: 100%" class="text-center mt-5">
              <h3 class="mt-5 text-white text-header-banner-48px">
                <b
                  >Students! Fast track your study by watching <br />
                  our vast online class video collection</b
                >
              </h3>
            </div>

            <div style="width: 40%" class="float-left d-sm-down-none">
              <div class="top-left mb-3 mt-5">
                <label class="text-white">Chemistry</label>
                <h3 class="mt-2 text-white text-header-banner-48px">
                  <b>
                    Physical Properties of Ionic <br />
                    Compounds and Covalent Compounds</b
                  >
                </h3>

                <label class="text-white-subtitle mt-3 text-16px">
                  In this video, you will learn melting and boiling points:
                  Ionic compounds tend to have higher melting and boiling points
                  than covalent compounds. Mechanical properties
                </label>
                <br /><br />

                <div style="width: 50%" class="float-left">
                  <div class="top-left">
                    <label class="text-white">
                      Tutor by Sir Lee Ming Kai
                    </label>
                    <label class="ml-5 text-white">1 hr 30 mins</label>
                    <br /><br />
                    <img
                      src="../assets/img/iconstaryellow.png"
                      style="height: 20px"
                    />
                    <img
                      src="../assets/img/iconstaryellow.png"
                      style="height: 20px"
                      class="mr-2"
                    />
                    <img
                      src="../assets/img/iconstaryellow.png"
                      style="height: 20px"
                      class="mr-2"
                    />
                    <img
                      src="../assets/img/iconstaryellow.png"
                      style="height: 20px"
                      class="mr-2"
                    />
                    <img
                      src="../assets/img/iconstaryellow.png"
                      style="height: 20px"
                      class="mr-2"
                    />
                    <label class="ml-2 text-white">1235 rating</label>
                    <br /><br />
                    <CButton
                      color="info"
                      class="custom-btn-login-active-signin mt-2 mb-5"
                      @click="GoToPlayVideo()"
                      style="width:200px"
                    >
                      Watch Video
                      <img class="ml-2" src="../assets/img/video.svg"
                    /></CButton>
                  </div>
                </div>
              </div>
            </div>

            <div style="width: 100%" class="float-left d-md-none">
              <div class="top-left mb-3 mt-5">
                <label class="text-white">Chemistry</label>
                <h3 class="mt-2 text-white text-header-banner-48px">
                  <b>
                    Physical Properties of Ionic <br />
                    Compounds and Covalent Compounds</b
                  >
                </h3>

                <label class="text-white-subtitle mt-3 text-16px">
                  In this video, you will learn melting and boiling points:
                  Ionic compounds tend to have higher melting and boiling points
                  than covalent compounds. Mechanical properties
                </label>
                <br /><br />

                <div style="width: 50%" class="float-left">
                  <div class="top-left">
                    <label class="text-white">
                      Tutor by Sir Lee Ming Kai
                    </label>
                    <label class="ml-5 text-white">1 hr 30 mins</label>
                    <br /><br />
                    <img
                      src="../assets/img/iconstaryellow.png"
                      style="height: 20px"
                    />
                    <img
                      src="../assets/img/iconstaryellow.png"
                      style="height: 20px"
                      class="mr-2"
                    />
                    <img
                      src="../assets/img/iconstaryellow.png"
                      style="height: 20px"
                      class="mr-2"
                    />
                    <img
                      src="../assets/img/iconstaryellow.png"
                      style="height: 20px"
                      class="mr-2"
                    />
                    <img
                      src="../assets/img/iconstaryellow.png"
                      style="height: 20px"
                      class="mr-2"
                    />
                    <label class="ml-2 text-white">1235 rating</label>
                    <br /><br />
                    <CButton
                      color="info"
                      class="custom-btn-login-active-signin mt-2 mb-5"
                      @click="GoToPlayVideo()"
                      style="width:200px"
                    >
                      Watch Video
                      <img class="ml-2" src="../assets/img/video.svg"
                    /></CButton>
                  </div>
                </div>
              </div>
            </div>

            <div style="width: 60%" class="float-right d-sm-down-none">
                <br/><br />
              <img
                class="mt-5"
                style="max-width: 100%"
                src="../assets/img/icon/bannerhomepage.svg"
              />
            </div>

            <div style="clear: both"></div>

            <br /><br /><br /><br />
          </CRow>
        </div>
      </CRow>
    </div>

    <CCol sm="12" class="bg-white">
      <CRow class="p-2">
        <CCol sm="4">
          <div class="p-5">
            <img style="max-width:80%" src="../assets/img/keyboard.svg" />
            <br /><br />
            <CButton
                      color="info"
                      class="custom-btn-login-active-signin mt-2 mb-5"
                      @click="GoToPlayVideo()"
                      style="width:200px"
                    >
                      All Video
                      <img class="ml-2" src="../assets/img/video.svg"
                    /></CButton>
          </div>
           </CCol>
        <CCol sm="8">
          <h3 class="text-custom-black mt-4"><b>Recent Searches</b></h3>
          <CRow>
              <hooper
                settings="hooperSettings"
                ref="hooper"
                :itemsToShow="4"
                pagination="yes"
                class="d-sm-down-none"
                :wheelControl='false'
              >
                <slide
                  v-for="(slide, index) in just"
                  :key="slide.Id"
                  :index="slide.Id"
                >
                  <CCard
                    style="width: auto;max-height:350px;"
                    class="custom-card-advertise custom-blue-card mb-2" >
                    <span class="custom-type-exam-left">
                      <label class="ml-2">{{ slide.exam }}</label>
                    </span>
                    <img
                      v-if="slide.filePath != null"
                      :src="getPicTeachers(index)"
                      style="max-width: 100%"
                      class="custom-bg-advetise"
                    />
                    <img
                      v-else
                      src="../assets/img/Thumnail3.svg"
                      class="custom-bg-advetise"
                    />
                    <div class="bg-linear">
                      <label class="ml-2 small text-white"
                        >{{ slide.subjectName }} - {{ slide.grade }}</label
                      >
                      <label class="custom-text-adv-header ml-2">
                        {{ slide.topic }}
                      </label>
                      <img
                        src="../assets/img/icon/iconstar.svg"
                        class="ml-2 mt-1"
                      />
                      <label
                        class="float-right custom-label-text mr-2 mt-1"
                      ></label>
                    </div>
                  </CCard>
                </slide>

                <hooper-navigation slot="hooper-addons"></hooper-navigation>
              </hooper>

              <hooper
                settings="hooperSettings"
                ref="hooper"
                :itemsToShow="2"
                pagination="yes"
                class="d-sm-flex d-md-none"
                :wheelControl='false'
              >
                <slide
                  v-for="(slide, index) in just"
                  :key="slide.Id"
                  :index="slide.Id"
                  @touchstart.prevent=""
                >
                  <CCard
                    style="width: auto"
                    class="custom-card-advertise custom-blue-card mb-2">
                    <span class="custom-type-exam-left">
                      <label class="ml-2">{{ slide.exam }}</label>
                    </span>
                    <img
                      v-if="slide.filePath != null"
                      :src="getPicTeachers(index)"
                      style="max-width: 100%"
                      class="custom-bg-advetise"
                    />
                    <img
                      v-else
                      src="../assets/img/Thumnail3.svg"
                      class="custom-bg-advetise"
                    />
                    <div class="bg-linear">
                      <label class="ml-2 small text-white"
                        >{{ slide.subjectName }} - {{ slide.grade }}</label
                      >
                      <label class="custom-text-adv-header ml-2">
                        {{ slide.topic }}
                      </label>
                      <img
                        src="../assets/img/icon/iconstar.svg"
                        class="ml-2 mt-1"
                      />
                      <label
                        class="float-right custom-label-text mr-2 mt-1"
                      ></label>
                    </div>
                  </CCard>
                </slide>

                <hooper-navigation slot="hooper-addons"></hooper-navigation>
              </hooper>
            </CRow>

          <h3 class="text-custom-black mt-3"><b>Popular Search This Week</b></h3>
          <CRow>
            <CCard
              class="custom-card-advertise custom-purple-card mb-2"
              v-for="item in popular.slice(0, 4)"
              v-bind:key="item.Id"
              style="max-height:350px"
            >
              <span class="custom-type-exam-left">
                <label class="ml-2">{{ item.exam }}</label>
              </span>
              <img
                v-if="item.filePath != null"
                :src="getPicPopular(item)"
                style="max-width: 100%"
                class="custom-bg-advetise"
              />
              <img
                v-else
                src="../assets/img/ch1.svg"
                class="custom-bg-advetise"
              />
              <div class="bg-linear">
                <label class="ml-2 small text-white"
                  >{{ item.subjectName }} - {{ item.grade }}</label
                >
                <label class="custom-text-adv-header ml-2">
                  {{ item.topic }}
                </label>

                <label class="float-right custom-label-text mr-2 mt-1"></label>
              </div>
            </CCard>
          </CRow>
        </CCol>
      </CRow>
    </CCol>


    <CCol sm="12" style="background: #007CEF;">
        <CRow>
            <CCol sm="3">
                <img src="../assets/img/teacher.svg" style="max-width: 100%" />
            </CCol>
            <CCol sm="4">
                <br /><br />
                <h3 class="text-dark-grey mt-5">
                    <b>Teachers, earn <br />
                    for your skill!</b>
                </h3>
                <br />

                <label class="text-custom-white">
                    Earn more money by sharing your <br />online classes on our platform <br /> and reaching a larger audience.
                </label>
                <CButton type="button" class="custom-btn-login-active-signin mt-2" @click="GoToCheck()">Check it out!</CButton>
                <br />
            </CCol>
            <CCol sm="5">
                <br />
                <img src="../assets/img/earn.svg" class="mt-5 mr-3" style="max-width: 100%"/>
                <br /> <br />
            </CCol>
            <br /> <br />
        </CRow>

    </CCol>

    <Footerlayout></Footerlayout>
  </div>
  </body>
</div>
</template>
  
  
  
  
  <script>
import Vue from "vue";
import VueMeta from "vue-meta";

Vue.use(VueMeta);
import AnimatedNumber from "animated-number-vue";
import backgroundUrl from "../assets/img/bg3.png";

// import Translator from "vue-gtranslate";
// import "vue-gtranslate/translator.css";

Vue.use(require("vue-moment"));
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";

import Mainlayout from "../containers/AllHeaderLanding.vue";
import Footerlayout from "../containers/TheFooter.vue";

import VueAgile from "vue-agile";
Vue.use(VueAgile);

// in component

import AOS from "aos";
import "aos/dist/aos.css";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);

import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";

import _ from "lodash";
import $ from "jquery";
import "hooper/dist/hooper.css";

import MenuIcon from "vue-material-design-icons/Menu.vue";
import { Hooper, Slide, Navigation as HooperNavigation } from "hooper";
new Vue({
  el: "#navbar",

  data() {
    return {
      view: {
        topOfPage: true,
      },
    };
  },
  beforeMount() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (window.pageYOffset > 400) {
        if (this.view.topOfPage) {
          this.view.topOfPage = false;
          el.setAttribute(
            "style",
            "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
          );
        }
      } else {
        if (!this.view.topOfPage) this.view.topOfPage = true;
        el.setAttribute(
          "style",
          "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
        );
      }
    },
  },
});
export default {
  metaInfo: {
    title: 'PickiddoTv - Fast track your study by watching our vast online class video collection',
    meta: [
      { property: 'og:title', content: 'PickiddoRv - Fast track your study by watching our vast online class video collection' }
    ],
    link: [
        { rel: 'canonical', href: 'https://www.pickiddo.com/PickiddoTv' }
      ]
  },
  name: "Login",
  components: {
    Slide,
    VueCal,
    MenuIcon,
    agile: VueAgile,
    Mainlayout,
    AnimatedNumber,
    backgroundUrl,
    Footerlayout,
    Hooper,
    HooperNavigation,
  },
  data() {
    return {
      slides: 5,
      selectedGrade: "SELECT GRADE",
      selectedGradeAll: "SELECT GRADE",
      gradeOptions: [],
      FilteredGrades: [],

      FilteredGradesAll: [],

      counter: "",
      round: "",

      scheduleclass: true,
      others: false,

      isShowPrimary: true,
      isShowSecondary: false,

      SearchQuery: "",
      FilterBySubject: [],
      popular: [],
      just: [],
      hooperSettings: {
      autoPlay: false,
      mouseDrag: false,
      touchDrag: false,
      infiniteScroll: false,
      wheelControl: false,
      itemsToShow: 4,
      centerMode: true,
      breakpoints: {
        800: {
          centerMode: false,
        },
        1000: {
          pagination: "fraction",
        },
      },
    },
    };
  },
  created() {
    AOS.init();
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
    this.GetListVideoPopular();
     this.GetListVideoJustForYou();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  computed: {
   
  },

  methods: {
    ReloadButton() {
      window.open("https://www.pickiddo.com/home", "_self");
    },
    
    onScroll() {
      // Get the current scroll position
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      if (currentScrollPosition < 0) {
        return;
      }
      // Here we determine whether we need to show or hide the navbar
      this.showNavbar = currentScrollPosition < this.lastScrollPosition;
      // Set the current scroll position as the last scroll position
      this.lastScrollPosition = currentScrollPosition;
    },
    handleScroll() {
      if (window.pageYOffset > 1000) {
        if (this.view.topOfPage) {
          this.view.topOfPage = false;
        } else {
          this.view.topOfPage = true;
        }
      }
    },
  
    GoToLogin() {
      window.open("https://app.pickiddo.com/v3/#/LoginPickiddo");
    },
    GoToPlayVideo() {
      window.open("https://tv.pickiddo.com");
    },
    
    GetListVideoPopular() {
      this.$API.get(this.$GetListPopular).then((response) => {
        if (response.status == 200 && response.data != null) {
          this.popular = response.data;
          this.getPicPopular(this.popular.filePath);
          this.getPicBanner(this.popular.filePathBanner);
          this.logDuration(this.popular.fileVideo);
        }
      });
    },
    getPicPopular(item) {
      return (
        "https://d3us0m7iuwh1d3.cloudfront.net/" + item.filePath
      );
    },
    getPicBanner(index) {
      return (
        "https://d3us0m7iuwh1d3.cloudfront.net/" +
        this.popular[index].filePathBanner
      );
    },
    logDuration(index) {
      durationVideos =
        "https://d3us0m7iuwh1d3.cloudfront.net/" +
        this.popular[index].fileVideo;
      //  this.durationVideo = this.$refs.durationVideos.duration;
      console.log("masuk", this.durationVideo);

      var x = this.$refs.durationVideos.duration;
      return x;
    },
    GoToCheck()
    {
        this.$router.push("CheckTv");
    },
    GetListVideoJustForYou() {
      this.$API.get(this.$GetListVideoJustForYou).then((response) => {
        if (response.status == 200 && response.data != null) {
          this.just = response.data;
          this.getPicTeachers(this.just.filePath);
        }
      });
    },
    getPicTeachers(index) {
      return (
        "https://d3us0m7iuwh1d3.cloudfront.net/" + this.just[index].filePath
      );
    },
  },
};
</script>
      <<style scoped>
  
  @import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
  @import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");
      
  .c-header {
    /* background: rgb(23, 77, 124);
    background: linear-gradient(92deg, #174d7c, #1b7682);
    border-bottom: 0.01px solid #1a6783;
    border-bottom: 1px solid #636f83; */
  
    background: transparent;
    border-bottom: 0;
    border-bottom: 0;
    /* color: #fff; */
  }
  .c-app{
    background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
    font-family: 'Montserrat', sans-serif;
  }
  body {
    font-family: "Montserrat", sans-serif;
    background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  }
  h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
      margin-bottom: 0.5rem;
      font-weight: 500;
      line-height: 1.2;
      font-family: "Montserrat", sans-serif;
  }
  label
  {
    font-family: "Montserrat", sans-serif;
  }
  
  body nav.onScroll {
    box-shadow: 0 0 10px #aaa;
    background-color: rgb(255, 255, 255);
    font-family: 'Montserrat';
  font-style: normal;
  }
  body nav.onScroll ul li {
    color: #10b761;
  }
  body nav ul {
    margin-left: 3em;
    width: 25%;
    display: flex;
    justify-content: space-between;
  }
  body nav ul li {
    cursor: pointer;
    font-weight: 600;
    list-style-type: none;
    color: white;
  }
  body {
      top: 0 !important;
      font-family: 'Montserrat', sans-serif;
  }
  li{
    font-family: 'Montserrat', sans-serif;
  }
  .centered {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  
.custom-input-text input[type="text"] ::placeholder {
  color: #fff;
}
.custom-input-text input[type="text"]::placeholder {
  color: #fff;
}
.hooper {
    position: relative;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    height: auto;
}
      </style>